'use strict';

/**
 * @ngdoc directive
 * @name gfcmsApp.directive:gfJobArrival
 * @description
 * # gfJobArrival
 */
angular.module('gfcmsApp').directive('gfJobArrival', JobArrival);

function JobArrival() {
  return {
    template: '<p ng-show="!!jobArrivalVm.job.arrived">' +
      '  Arrived {{ jobArrivalVm.job.arrived | amCalendar:referenceTime:formats }}' +
      '</p>' +
      '<button class="btn btn-success" ng-show="!jobArrivalVm.job.arrived"' +
      'ng-disabled="jobArrivalVm.job.progress"' +
      '        ng-click="jobArrivalVm.arrivedJob()">' +
      '  <i class="fa fa-finish"></i>Arrived' +
      '</button>',
    restrict: 'E',
    link: postLink,
    scope: {
      job: '='
    },
    controller: JobArrivalController,
    controllerAs: 'jobArrivalVm',
    bindToController: true
  };

  function postLink(scope, element, attrs) {
    // element.text('this is the gfJobArrival directive');
  }
}

JobArrivalController.$inject = ['$scope', 'moment', 'jobService', 'modalService', 'FlashService'];

function JobArrivalController($scope, moment, jobService, modalService, FlashService) {
  var jobArrivalVm = this;
  jobArrivalVm.arrivedJob = arrivedJob;
  jobArrivalVm.job.progress = false;
  return jobArrivalVm;

  function arrivedJob() {
    /**
     * @type {{arrived: string, id: string, progress: boolean}}
     */
    var job = jobArrivalVm.job;
    job.progress = true;
    jobService.arrivedJob(job.id)
      .then(
        /**
         * @param {JobArrival} response
         */
        function (response) {
          /**
           * @type Moment
           */
          var arrivedMoment = moment(response.arrived);
          job.arrived = arrivedMoment.format();
          FlashService.Success('Arrival recorded');
        })
      .catch(function () {
        FlashService.Error('Recording arrival failed');
      })
      .finally(function () {
        job.progress = false;
      });
  }
}
